import { BookingStatus } from "../../constants/securspace-constants";
import { formatCurrencyValue } from "../../../util/PaymentUtils";
import { formatFrequency } from "@securspace/securspace-ui-kit";
import { assetTypeOptions, frequencyOptions, BookingStatusGroups } from "../data";

import moment from "moment";

const sortByFields = [
  {label: "Booking Number", value: "ORDER_NUMBER"},
  {label: "Buyer", value: "BUYER_COMPANY_NAME"},
  {label: "Start Date", value: "START_DATE"}
];

const filterBySelectOption = [
  {
    label: "Equipment Type",
    value: "",
    name: "equipmentType",
    option: assetTypeOptions
  },
  {
    label: "Frequency",
    value: "",
    name: "frequency",
    option: frequencyOptions
  }
];

const supplierHeaderCells = [
  { id: 'orderNumber', label: 'BOOKING NUMBER' },
  { id: 'buyerCompanyName', label: 'Buyer' },
  { id: 'startDateValue', label: 'Start Date' },
  { id: 'endDateValue', label: 'End Date' },
  { id: 'numberOfSpaces', label: 'Number of Spaces' },
  { id: 'locationName', label: 'Location' },
  { id: 'brokered', label: 'Brokered' },
  { id: 'frequencyValue', label: 'Frequency' },
  { id: 'assetType', label: 'Equipment Type' },
  { id: 'rate', label: 'Booking Rate' },
  { id: 'status', label: 'STATUS' },
  { id: 'createdOn', label: 'Created On' },
];

const shouldShowEndDate = (data, bookingStatusLabel) => {
  const yearWeWillAllBeDeadBy = '2200'
  const isDateWeWillAllBeDeadBy = moment(data.endDate).year().toString() === yearWeWillAllBeDeadBy;
  return (
    data.frequency === 'RECURRING' &&
    data.endDateAdjusted !== true &&
    isDateWeWillAllBeDeadBy &&
    (data.active === true || data.status === bookingStatusLabel.PENDING || data.status === bookingStatusLabel.INCOMPLETE)
  );
};

function transformBooking(booking) {
  const commonProperties = {
    initialSupplierPayoutAmount: formatCurrencyValue(booking.initialCharge, true),
    recurringSupplierPayoutAmount: formatCurrencyValue(booking.recurringSupplierPayoutAmount, true),
    frequencyValue: formatFrequency(booking.frequency, booking.durationType),
    startDateValue: moment(booking.startDate).format("L h:mm a").toUpperCase(),
    createdOn: moment(booking.createdOn).format("L h:mm a").toUpperCase(),
    supplierCompanyName: booking.supplierCompanyName ? booking.supplierCompanyName : 'N/A',
    active: booking.active ? 'Active' : 'Not Active',
    brokered: booking.brokered ? 'True' : 'False',
    endDateValue: shouldShowEndDate(booking, BookingStatus) ? 'Until cancelled' : `${moment(booking.endDate).format("L h:mm a").toUpperCase() || "N/A"}`,
    rate: booking.brokered ? 'N/A' : formatCurrencyValue(booking.rate) + (booking.durationType === 'WEEKLY' ? ' /week' : booking.durationType === 'MONTHLY' ? ' /month' : ' /day'),
  };

  return {
    ...booking,
    ...commonProperties
  };
};

const SupplierBookingTabs = Object.freeze({
  ACTIVE: BookingStatusGroups.ACTIVE,
  PENDING: BookingStatusGroups.PENDING,
  INACTIVE: BookingStatusGroups.INACTIVE,
  FAILED: BookingStatusGroups.FAILED,
});

export {
    sortByFields,
    supplierHeaderCells,
    filterBySelectOption,
    transformBooking,
    SupplierBookingTabs
}